import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import donationHeaderFearlessSignup from "../../../../src/content/fearless-email-sign-up/donationHeader";
import * as React from 'react';
export default {
  NewNamesForm,
  donationHeaderFearlessSignup,
  React
};